/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgUserSelfUpdateV1
 */
export interface OrgUserSelfUpdateV1 {
    /**
     * 
     * @type {string}
     * @memberof OrgUserSelfUpdateV1
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserSelfUpdateV1
     */
    last_name: string;
}

/**
 * Check if a given object implements the OrgUserSelfUpdateV1 interface.
 */
export function instanceOfOrgUserSelfUpdateV1(value: object): value is OrgUserSelfUpdateV1 {
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    return true;
}

export function OrgUserSelfUpdateV1FromJSON(json: any): OrgUserSelfUpdateV1 {
    return OrgUserSelfUpdateV1FromJSONTyped(json, false);
}

export function OrgUserSelfUpdateV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgUserSelfUpdateV1 {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'],
        'last_name': json['last_name'],
    };
}

export function OrgUserSelfUpdateV1ToJSON(json: any): OrgUserSelfUpdateV1 {
    return OrgUserSelfUpdateV1ToJSONTyped(json, false);
}

export function OrgUserSelfUpdateV1ToJSONTyped(value?: OrgUserSelfUpdateV1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'last_name': value['last_name'],
    };
}

